module.exports = __webpack_public_path__ + "static/media/air-conditioner.75e2eaa0.svg";